import { Injectable } from '@angular/core';
import { BaseNavigationService } from './base-navigation.service';
import { NavigationService } from '../../../core/navigation/services/navigation.service';
import { TranslateService } from '@ngx-translate/core';
import { MessagesType } from '../../../messages/models/enums/messages-type.enum';
import { MessagesManagementService } from '../../../messages/services/messages-management.service';

@Injectable()
export class BatchesNavigationService extends BaseNavigationService {

  protected get systemQueueType() {
    return 'system_queues_batches';
  }

  protected get customQueueType() {
    return 'custom_queues_batches';
  }

  protected get entityTypeGrid() {
    return '.entity.batches.grid';
  }

  get type() {
    return MessagesType.BATCHES;
  }

  constructor(protected navigationService: NavigationService,
              protected translateService: TranslateService,
              protected entityService: MessagesManagementService) {
    super(navigationService, translateService, entityService);
  }
}
